'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../node_modules/@fortawesome/pro-regular-svg-icons/index.cjs');
var index_es = require('../../../../../../node_modules/@fortawesome/react-fontawesome/index.es.cjs');
var Tooltip_web = require('../../atoms/Tooltip/Tooltip.web.cjs');
var InternalButtonLink_web = require('../InternalButtonLink/InternalButtonLink.web.cjs');
var InternalInputIcon_web_styles = require('./InternalInputIcon.web.styles.cjs');

/**
 * Icons for input fields
 *
 * When it's a button, all functionality can be disabled
 * when it's a tooltip, it will still function even when disabled
 */ const InternalInputIcon = ({ icon, disabled = false, tooltipContent = "", onClick, "aria-label": ariaLabel = "" })=>{
    let selectedIcon = null;
    switch(icon){
        case "info":
            selectedIcon = index.faInfoCircle;
            break;
        case "passwordHidden":
            selectedIcon = index.faEyeSlash;
            break;
        case "passwordVisible":
            selectedIcon = index.faEye;
            break;
        case "calendar":
            selectedIcon = index.faCalendarDay;
            break;
        case "caratDown":
            selectedIcon = index.faAngleDown;
            break;
        case "caratUp":
            selectedIcon = index.faAngleUp;
            break;
        case "search":
            selectedIcon = index.faSearch;
            break;
        case "close":
            selectedIcon = index.faTimes;
            break;
        default:
            selectedIcon = index.faInfoCircle;
            break;
    }
    const renderedIcon = /*#__PURE__*/ jsxRuntime.jsx(index_es.FontAwesomeIcon, {
        icon: selectedIcon,
        css: InternalInputIcon_web_styles.icon
    });
    const renderWrapper = ()=>{
        if (onClick) {
            return /*#__PURE__*/ jsxRuntime.jsx(InternalButtonLink_web.InternalButtonLink, {
                onClick: onClick,
                disabled: disabled,
                css: [
                    InternalInputIcon_web_styles.iconWrapper,
                    InternalInputIcon_web_styles.active,
                    InternalInputIcon_web_styles.hover,
                    disabled && InternalInputIcon_web_styles.disabled
                ],
                "data-testid": "aviary-input-icon-button",
                "aria-label": ariaLabel,
                children: renderedIcon
            });
        }
        if (tooltipContent) {
            return /*#__PURE__*/ jsxRuntime.jsx(Tooltip_web.Tooltip, {
                tooltipContent: tooltipContent,
                customCss: [
                    InternalInputIcon_web_styles.iconWrapper,
                    InternalInputIcon_web_styles.hover
                ],
                "data-testid": "aviary-input-icon-tooltip",
                "aria-label": ariaLabel,
                alignment: "top",
                children: renderedIcon
            });
        }
        return /*#__PURE__*/ jsxRuntime.jsx("span", {
            css: InternalInputIcon_web_styles.iconWrapper,
            children: renderedIcon
        });
    };
    return renderWrapper();
};

exports.InternalInputIcon = InternalInputIcon;
//# sourceMappingURL=InternalInputIcon.web.cjs.map
